var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34942 1.5C4.71402 1.50475 3.33397 1.56946 2.45202 2.45155C1.50024 3.40348 1.50024 4.93559 1.50024 7.99978C1.50024 11.064 1.50024 12.5961 2.45202 13.548C3.40379 14.5 4.93566 14.5 7.99943 14.5C11.0631 14.5 12.595 14.5 13.5467 13.548C14.4287 12.666 14.4934 11.2856 14.4981 8.64986M14.1795 1.85808L7.31308 8.7644M14.1795 1.85808C13.8228 1.50086 11.4194 1.53416 10.9113 1.54139M14.1795 1.85808C14.5363 2.21531 14.503 4.62178 14.4958 5.13053",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/navigation-icon.09d4f960c4c9c0e39eec2d0c5d45e1e9.svg";
export { ForwardRef as ReactComponent };